/**
 * Bottom-left filter pills on the map canvas.
 * Following is real: count + filter backed by the orchestrator's
 * localStorage-persisted followed set.
 */

import React from 'react';

import { cn } from '@/lib/utils';

export type Filter = 'all' | 'live' | 'following';

export const FilterStrip: React.FC<{
  filter: Filter;
  onChange: (f: Filter) => void;
  total: number;
  live: number;
  following: number;
  /** Position overrides (e.g. lift above the mobile mini player). */
  className?: string;
}> = ({ filter, onChange, total, live, following, className }) => (
  <div
    className={cn(
      'absolute bottom-4 left-4 z-[1000] flex gap-1.5 rounded-full border border-white/10 bg-black/70 p-1.5 backdrop-blur',
      className,
    )}
  >
    <FilterPill active={filter === 'all'} onClick={() => onChange('all')}>
      All · {total}
    </FilterPill>
    <FilterPill active={filter === 'live'} onClick={() => onChange('live')}>
      Live · {live}
    </FilterPill>
    <FilterPill active={filter === 'following'} onClick={() => onChange('following')}>
      Following · {following}
    </FilterPill>
  </div>
);

const FilterPill: React.FC<{
  active: boolean;
  onClick: () => void;
  children: React.ReactNode;
}> = ({ active, onClick, children }) => (
  <button
    type="button"
    onClick={onClick}
    className={cn(
      'rounded-full px-3 py-1 text-[10px] font-semibold uppercase tracking-wide',
      active ? 'bg-accent text-fg-inverse' : 'text-fg-secondary hover:text-fg',
    )}
  >
    {children}
  </button>
);

export default FilterStrip;
